import React from "react";
import Modal from "react-modal";
import Router from "next/router";

const TimeOut = ({ isOpen, url }) => {
	return (
		<>
			<Modal
				isOpen={isOpen}
				shouldCloseOnEsc={false}
				shouldCloseOnOverlayClick={false}
				className="react-modal timeout"
			>
				<div className="row p-3 justify-content-center text-center">
					<div>
						<img src="/img/modal/SessionTimeOut.svg" className="error-warning" />
					</div>
					<div className="mt-3">
						<h3 className="timeout-title">Session Timeout!</h3>
					</div>

					<div>
						<p className="timeout-content">
							Your session expired as you did not complete the
							<br />
							registration process within the time limit.
						</p>
					</div>

					<div>
						<button
							className="btn btn-theme mb-3"
							type="button"
							onClick={() => Router.reload(url)}
						>
							<i className="fa fa-refresh mr-2"></i>
							Refresh
						</button>
					</div>
				</div>
			</Modal>
			<style jsx>{`
				.timeout-title {
					font-weight: 600;
					font-size: 24px;
					line-height: 33px;
					text-align: center;
					color: #dc3545;
				}

				.timeout-content {
					font-weight: 500;
					font-size: 16px;
					line-height: 25px;
					text-align: center;
					color: #572148;
				}
				.time-img {
					margin-right: 11px;
					margin-top: -2px;
				}
			`}</style>
		</>
	);
};

export default TimeOut;
